import { render } from "./CreateExternalReferral.vue?vue&type=template&id=b60ec33c"
import script from "./CentralExternalReferral.ts?vue&type=script&lang=js&external"
export * from "./CentralExternalReferral.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__